<script>
export default {};
</script>

<template>
  <card :title="'Relatório de Ofertas'">
  </card>
</template>
